import { GET, POST, PUT } from '../http';
import { endpoint } from '../../api/http';

export const UploadFile = async (formData) => {
	return new Promise((resolve, reject) => {
		var request = new XMLHttpRequest();
		request.open('POST', `${endpoint}PMS/DocumentsAndImages/UploadImage`);
		request.onreadystatechange = () => {
			if (request.readyState === 4 && request.status === 200) {
				resolve();
			} else if (request.status !== 200) {
				reject(JSON.parse(request.responseText));
				request.onreadystatechange = null; //onreadystatechange is not cancelable and thus without this line, several error toasts are initiated
			}
		};
		request.send(formData);
	});
};
export const GetDocuments = (spec) => {
	return GET('PMS/DocumentsAndImages/GetDocuments', spec);
};

export const DeleteDocument = (spec) => {
	return POST('PMS/DocumentsAndImages/DeleteDocument', spec);
};

export const GetRooms = (spec) => {
	return GET('PMS/Rooms/GetRooms', spec);
};

export const GetReservations = (spec) => {
	return GET('PMS/Tapechart/GetReservations', spec);
};

export const GetReservation = (spec) => {
	return GET('PMS/Reservations/GetReservation', spec);
};

export const GetExternalChannelsList = (spec) => {
	return GET('PMS/Reservations/GetExternalChannelsList', spec);
};

export const SearchReservations = (spec) => {
	return GET('PMS/Reservations/SearchReservations', spec);
};

export const GetColumnData = (spec) => {
	return GET('PMS/Tapechart/GetTapechartColumnsData', spec);
};

export const GetReservationTotals = (spec) => {
	return POST('PMS/Reservations/GetReservationTotals', spec);
};

export const GetRoomTypes = (spec) => {
	return GET('PMS/RoomType/GetRoomTypes', spec);
};

export const GetProducts = (spec) => {
	return POST('PMS/ProductDataService/GetProducts', spec);
};

export const SaveReservation = (reservation) => {
	return POST('PMS/Reservations/SaveReservation', reservation);
};

export const UpdateReservationStatus = (reservation) => {
	return POST('PMS/Reservations/UpdateStatus', reservation);
};

export const UpdateReservationStatuses = (reservations) => {
	return POST('PMS/Reservations/UpdateStatuses', reservations);
};

export const UpdateReservationColor = (reservation) => {
	return POST('PMS/Reservations/UpdateColor', reservation);
};

export const SendConfirmationEmail = (reservation) => {
	return POST('PMS/Tapechart/SendMailToGuest', reservation);
};

export const SendMail = (spec) => {
	return POST('PMS/Reservations/SendMail', spec);
};

export const GetSentEmailHistory = (spec) => {
	return GET('PMS/Reservations/GetSentEmailHistory', spec);
};

export const SyncChannelManagerProducts = (spec) => {
	return POST('PMS/Reservations/SyncChannelManagerProducts', spec);
};

export const GetHotelKeyEncoders = (spec) => {
	return GET('PMS/Rooms/GetHotelKeyEncoders', spec);
};

export const PostKeyRequest = (spec) => {
	return GET('PMS/Rooms/PostKeyRequest', spec);
};

export const GetHotelInterfaces = (spec) => {
	return GET('PMS/Interfaces/GetHotelInterfaces', spec);
};

export const UpdateYields = (spec) => {
	return POST('PMS/HotelAvailability/UpdateYields', spec);
};
export const GetUnAssignedRoomCount = (spec) => {
	return GET('PMS/Reservations/GetUnAssignedRoomCount', spec);
};

export const SetRoomHousekeepingStatusLog = (spec) => {
	return POST('PMS/HotelHousekeeping/SetRoomHousekeepingStatusLog', spec);
};


export const GetPricingTypes = (spec) => {
	return GET('PMS/Reservations/GetPricingTypes', spec);
};

export const RecalculateReservationAmount = (spec) => {
	return POST('PMS/Reservations/RecalculateReservationAmount', spec);
};
export const GetDefaultReservationValues = (spec) => {
	return GET(
		'PMS/HotelDefaultReservationValues/GetDefaultReservationValues',
		spec
	);
};
export const GetReservationSources = (spec) => {
	return GET('PMS/ReservationSources/GetReservationSources', spec);
};

export const GetMarketSegments = (spec) => {
	return GET('PMS/MarketSegmentDataService/GetMarketSegments', spec);
};

export const GetReservationStatuses = (spec) => {
	return GET('PMS/ReservationStatusDataService/GetReservationStatuses', spec);
};

export const GetRates = (spec) => {
	return GET('PMS/RateDataService/GetRates', spec);
};

export const SyncRateToChannelManager = (spec) => {
	return POST('PMS/RateDataService/SyncRateToChannelManager', spec);
};

export const LiveUpdateHierarchyData = (spec) => {
	return POST('PMS/Live/LiveUpdateHierarchyData', spec);
};

export const UpdateProductPricesByPercentOrAmount = (spec) => {
	return POST('PMS/Live/UpdateProductPricesByPercentOrAmount', spec);
};
export const GetUrlCreditCard = (spec) => {
	return POST('PMS/Reservations/GetUrlCreditCard', spec);
};
export const GetPaymentProviderCvvSession = (spec) => {
	return GET('PMS/Reservations/GetPaymentProviderCvvSession', spec);
};
export const GetPaymentProviderURL = (spec) => {
	return GET('PMS/Reservations/GetPaymentProviderURL', spec);
};
export const GetPaymentProviderTransaction = (spec) => {
	return GET('PMS/Reservations/GetPaymentProviderTransaction', spec);
};

export const GetPaymentTokenEntity = (spec) => {
	return GET('PMS/Reservations/GetPaymentTokenEntity', spec);
};

export const CreateReservationGroup = (spec) => {
	return POST('PMS/ReservationGroupDataService/CreateReservationGroup', spec);
};
export const UpdateReservationGroup = (spec) => {
	return PUT('PMS/ReservationGroupDataService/UpdateReservationGroup', spec);
};
export const GetReservationGroups = (spec) => {
	return GET('PMS/ReservationGroupDataService/GetReservationGroups', spec);
};

export const CalculateTotalAmountCurrentReservation = (spec) => {
	return POST('PMS/Reservations/CalculateTotalAmountCurrentReservation', spec);
};
export const UpsertGroupBlock = (resGroupRes) => {
	return POST('PMS/ReservationGroupDataService/UpsertGroupBlock', resGroupRes);
};

export const GetReservationCategories = () => {
	return GET('PMS/Reservations/GetReservationCategories');
};

export const UpdateReservationGroupReservations = (resGroupRes) => {
	return POST(
		'PMS/ReservationGroupDataService/UpdateReservationGroupReservations',
		resGroupRes
	);
};

export const RerouteGroupReservations = (reservationRerouteSpecification) => {
	return POST(
		'PMS/ReservationGroupDataService/RerouteGroupReservations',
		reservationRerouteSpecification
	);
};

export const GetReservationPaymentArrangmentTransactionCodeGroups = (spec) => {
	return GET(
		'PMS/Reservations/GetReservationPaymentArrangmentTransactionCodeGroups',
		spec
	);
};

export const GetHotelAvailability = (availabilityInternalSpecification) => {
	return GET(
		'PMS/HotelAvailability/GetHotelAvailability',
		availabilityInternalSpecification
	);
};

export const RecalculateAvailabilityBySpecification = (recalcAvailabilitySpec) => {
	return POST(
		'PMS/HotelAvailability/RecalculateAvailabilityBySpecification',
		recalcAvailabilitySpec
	);
};

export const SendGroupConfirmationToGuest = (reservation) => {
	return POST(
		'PMS/ReservationGroupDataService/SendGroupConfirmationToGuest',
		reservation
	);
};

export const GetHotelAvailabilitySchedulerData = (spec) => {
	return GET('PMS/HotelAvailability/GetHotelAvailabilitySchedulerData', spec);
};

export const GetProductPricesForCalendar = (spec) => {
	return GET('PMS/HotelAvailability/GetProductPricesForCalendar', spec);
};

export const GetDataForRestrictionsPageNew = (spec) => {
	return POST('PMS/Restriction/GetDataForRestrictionsPageNew', spec);
};

export const GetProductPrices = (spec) => {
	return GET('PMS/Reservations/GetProductPrices', spec);
};

export const GetGuestInHouse = (spec) => {
	return GET('PMS/Reservations/GetGuestInHouse', spec);
};

export const UpdateComments = (spec) => {
	return POST('PMS/Reservations/UpdateComments', spec);
};

export const RenderTemplate = (spec) => {
	return POST('PMS/Reservations/RenderTemplate', spec);
};

export const RenderTemplateToPdf = (spec) => {
	return POST('PMS/Reservations/RenderTemplateToPdf', spec);
};
export const GetTapechartDisplaySettings = (spec) => {
	return GET('PMS/TapechartDisplaySettings/GetTapechartDisplaySettings', spec);
};

export const GetChainAddons = (spec) => {
	return GET('PMS/Addons/GetChainAddons', spec);
};

export const GetHotelAddons = (spec) => {
	return GET('PMS/Addons/GetHotelAddonsPerSpec', spec);
};

export const GetCancelReservations = (spec) => {
	return GET('PMSReports/SPAReports/GetCancelReservations', spec);
};

export const GetReservationsReport = spec=>{
    return GET("PMSReports/SPAReports/GetReservations", spec)
}

export const GetReservationsReportForHotelOwner = spec=>{
    return GET("PMSReports/SPAReports/GetReservationsReportForHotelOwner", spec)
}

export const GetOccupancyForecastData = spec=>{
    return GET("PMSReports/ForecastReports/GetOccupancyForecastData", spec)
}
export const GetRoomsForecastData = spec=>{
    return GET("PMSReports/ForecastReports/GetRoomsForecastData", spec)
}
export const GetGuestInHouseFilters = spec=>{
	return GET("PMS/Reservations/GetGuestInHouseFilters",spec)
}
